// src/hooks/useEventNotes.js
import { useState, useEffect } from 'react';
import { getNoteKey } from '../utils/dateHelpers';

/**
 * Hook do zarządzania notatkami eventów
 */
export function useEventNotes(date) {
    const [notes, setNotes] = useState({});

    const readNote = (ev) => {
        if (ev && typeof ev.note === 'string') return ev.note;
        try {
            const key = getNoteKey(date, ev);
            return localStorage.getItem(`evtNote:${key}`) || '';
        } catch {
            return '';
        }
    };

    const writeNote = (ev, text) => {
        try {
            const key = getNoteKey(date, ev);
            if (text && typeof text === 'string' && text.trim().length) {
                localStorage.setItem(`evtNote:${key}`, text);
            } else {
                localStorage.removeItem(`evtNote:${key}`);
            }
        } catch { }
    };

    return { readNote, writeNote };
}

